import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import Breadcrumb from "../Breadcrumb";
import Modal from "../Modal/Modal";
import { logoutUser } from "../../actions/user";
import { validateName, validateEmail } from "../../helpers/validation";
import "./UserCreate.css";

const UserCreate = React.memo(({ isFetching, user_info, createUser, fetchUserInfo }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    
    useEffect(() => {
        fetchUserInfo();
    }, [fetchUserInfo]);

    const [form, setForm] = useState({
        login_id: "",
        user_name: "",
    });

    const [errors, setErrors] = useState({
        login_id: "",
        user_name: "",
    });
    const [modalMessage, setModalMessage] = useState("");
    const [isModalOpen, setIsModalOpen] = useState(false);

     // 入力変更処理
    const handleChange = (e) => {
        const { name, value } = e.target;

        setForm({ ...form, [name]: value });

        // Clear error of the field being edited
        if (errors[name]) {
            setErrors({ ...errors, [name]: "" });
        }
    };

    // 登録ボタン押下時処理
    const handleSubmit = async () => {
        const newErrors = {};

        // --- Login ID ---
        const loginIdError = validateEmail(form.login_id);
        if (loginIdError) newErrors.login_id = loginIdError;

        // --- User Name ---
        const userNameError = validateName(form.user_name);
        if (userNameError) newErrors.user_name = userNameError;


        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }

        // Clear all errors
        setErrors({ login_id: "", user_name: ""});

        const result = await createUser(form);

        // 成功時 → 一覧画面へ遷移
        if (result?.payload) {
            navigate("/user-list");
            return;
        }

        // 失敗時 → モーダル表示
        if (result?.error) {
            setModalMessage(result.error || "エラーが発生しました。");
            setIsModalOpen(true);
        }
    };

    return (
        <div id="Main">
            <div id="Contents">
                <Breadcrumb 
                    user={user_info?.admin_name} 
                    onLogout={() => dispatch(logoutUser())}
                />

                {isModalOpen && (
                    <Modal
                        isOpen={isModalOpen}
                        onClose={() => setIsModalOpen(false)}
                        message={modalMessage}
                    />
                )}
                
                <div className="user-layout">
                    <div className="user-card">
                        <h2 className="user-create-title">ユーザー新規作成</h2>

                        <div className="btn-row">
                            <button className="btn-submit" onClick={handleSubmit}>登録</button>
                            <button className="btn-back" onClick={() => navigate("/user-list")}>戻る</button>
                        </div>
                        
                        <div className="user-create-form">
                            {/* LOGIN ID */}
                            <div className="form-row">
                                <label>メールアドレス</label>
                                <input name="login_id" value={form.login_id} onChange={handleChange} />
                            </div>
                            {errors.login_id && <p className="error-text">{errors.login_id}</p>}

                            {/* USER NAME */}
                            <div className="form-row">
                                <label>ユーザー名</label>
                                <input name="user_name" value={form.user_name} onChange={handleChange} />
                            </div>
                            {errors.user_name && <p className="error-text">{errors.user_name}</p>}

                        </div>
                    </div>

                </div>
            </div>
            <div className={`overlay ${isFetching ? 'active' : ''}`}>
                <div className={`spinner ${isFetching ? 'active' : ''}`}></div>
            </div>
        </div>
    );
});

UserCreate.displayName = "UserCreate";    // fix eslint(react/display-name)

UserCreate.propTypes = {
    isFetching: PropTypes.bool.isRequired,
    user_info: PropTypes.object,
    createUser: PropTypes.func.isRequired,
    fetchUserInfo: PropTypes.func.isRequired,
};

export default UserCreate;
